export * from './FileFormatPngIcon';
export * from './FileFormatPngIcon16Light';
export * from './FileFormatPngIcon16Regular';
export * from './FileFormatPngIcon16Solid';
export * from './FileFormatPngIcon20Light';
export * from './FileFormatPngIcon20Regular';
export * from './FileFormatPngIcon20Solid';
export * from './FileFormatPngIcon24Regular';
export * from './FileFormatPngIcon24Solid';
export * from './FileFormatPngIcon32Regular';
export * from './FileFormatPngIcon64Regular';
